import {UI_COLORS} from '@/utils/ui-colors';

export function getCmsFileCategoryColor(item) {
    return item && item.category && item.category.color ? item.category.color : UI_COLORS.border.default;
}

export function getCmsFileRowKey(item) {
    if (!item) {
        return 'missing-item';
    }

    return item.uuid || item.id || `${item.name || 'cms-file'}-${item.created_at || 'na'}`;
}

export function resolveCmsFileIcon(extension) {
    return 'font-awesome.regular.folders';
}

export function resolveCmsFileUserAvatar(actor) {
    if (!actor) {
        return '/images/default/avatar.svg';
    }

    if (actor.avatar && actor.avatar !== 'gravatar') {
        return actor.avatar;
    }

    if (actor.gravatar) {
        return actor.gravatar;
    }

    return '/images/default/avatar.svg';
}

export function isCmsImageFileExtension(extension) {
    const ext = String(extension || '').toLowerCase();
    return ['png', 'jpg', 'jpeg', 'gif', 'svg', 'bmp', 'webp'].includes(ext);
}

export function buildCmsShortDescriptionTooltip(text) {
    if (!text) {
        return '';
    }

    return String(text)
        .replace(/<[^>]*>/g, ' ')
        .replace(/&nbsp;/gi, ' ')
        .replace(/\s+/g, ' ')
        .trim();
}
